/* TecnoHogarJS 2026 — interacciones ligeras de la Home (sin librerías externas). */
(function () {
  'use strict';

  /* ---------- Carruseles con flechas (el desplazamiento táctil es nativo) ---------- */
  function initCarousel(root) {
    if (root.dataset.thxReady) return;
    root.dataset.thxReady = '1';
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var prev = root.querySelector('[data-dir="-1"]');
    var next = root.querySelector('[data-dir="1"]');

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    }
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        var dir = Number(btn.dataset.dir) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Agregar al carrito con el sistema real de Shopify ---------- */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(source, cart, sections, variantId) {
    // Mismo evento que usa el tema Horizon ("cart:update"): actualiza la burbuja y el carrito lateral.
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: String(variantId || ''),
      data: { source: 'thx-home', itemCount: cart ? cart.item_count : 0, variantId: String(variantId || ''), sections: sections || undefined }
    };
    source.dispatchEvent(ev);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-thx-atc]')) return;
    if (!window.fetch || !window.FormData) return; // sin JS moderno: envío normal a /cart/add
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.thx-card__msg');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (msg) msg.textContent = '';

    var fd = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) fd.append('sections', ids.join(','));
    var addUrl = (form.getAttribute('action') || '/cart/add').replace(/\/?$/, '') + '.js';
    var sections = null;

    fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'No se pudo agregar');
        sections = res && res.sections ? res.sections : null;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        dispatchCartUpdate(form, cart, sections, fd.get('id'));
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2200); }
        if (msg) msg.textContent = 'Producto agregado al carrito';
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) {
          try { drawer.open(); } catch (err) { /* sin carrito lateral */ }
        }
      })
      .catch(function (err) {
        if (msg) msg.textContent = err && err.message ? err.message : 'No se pudo agregar. Intenta de nuevo.';
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  }

  function init() {
    document.querySelectorAll('[data-thx-carousel]').forEach(initCarousel);
  }

  document.addEventListener('submit', onSubmit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Editor de temas: reinicializar al recargar secciones
  document.addEventListener('shopify:section:load', init);
})();
